<template>
	<div class="tagAdd">
		<div class="contentWrap"   element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
			<!-- 新增map -->
      <!-- <h3>{{imageType}}</h3> -->
      <!-- <h3>{{filelist_map_store}}</h3> -->
      <!-- 第一块 -->
			<div class="panelBlock">
        <div class="panelTitle">店面在地图上的图标</div>
        <div class="panelContent">
          <div class="uploadAreaWrap">

            <input type="text" placeholder="请输入图标文字说明" v-model="input_map_store">
            <el-button type='primary' class="btn" @click="submitClick('map_store')">新增图标</el-button>
            <el-upload     :on-remove="handleRemove_map_store"                  :on-exceed="exceedHandle"
             :file-list="filelist_map_store"             :name="'files'"              :data="uploadData_map_store"
              :action="api.baseUrl+'/file/uploadfilebatch'"              :on-success="addImgSuccessHandle_map_store"          list-type="picture">
              <div v-if="filelist_map_store.length==0" class="mytriggerDiv" slot="trigger" @click="addImgClick('map_store')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
            </el-upload>
          </div>

          <div class="listWrap">
            <div class="oneItem" v-for="(list,index) in list_map_store" >
              <img :src="IMG_PREV+list.tag_icon" alt="">
              <span class="imgDes"> {{list.tag_name}}</span>
              <span class="deleteIcon" @click='deleteTag(list)'>
                 <i class="el-icon-delete"></i>
              </span>
            </div>
          </div>
        </div>
			</div>
      <!-- 第2块 -->
      <div class="panelBlock">
        <div class="panelTitle">园区在地图上的图标</div>
        <div class="panelContent">
          <div class="uploadAreaWrap">

            <input type="text" placeholder="请输入图标文字说明" v-model="input_map_park">
            <el-button type='primary' class="btn" @click="submitClick('map_park')">新增图标</el-button>
            <el-upload             :on-remove="handleRemove_map_park"             :limit="1"             :on-exceed="exceedHandle"
             :file-list="filelist_map_park"             :name="'files'"              :data="uploadData_map_park"
              :action="api.baseUrl+'/file/uploadfilebatch'"              :on-success="addImgSuccessHandle_map_park"             list-type="picture">
              <div v-if="filelist_map_park.length==0" class="mytriggerDiv" slot="trigger" @click="addImgClick('map_park')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
            </el-upload>
          </div>

          <div class="listWrap">
            <div class="oneItem" v-for="(list,index) in list_map_park" >
              <img :src="IMG_PREV+list.tag_icon" alt="">
              <span class="imgDes"> {{list.tag_name}}</span>
              <span class="deleteIcon" @click='deleteTag(list)'>
                 <i class="el-icon-delete"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 第3块 -->
      <div class="panelBlock">
        <div class="panelTitle">园区标签</div>
        <div class="panelContent">
          <div class="uploadAreaWrap">

            <input type="text" placeholder="请输入标签文字说明" v-model="input_park">
            <el-button type='primary' class="btn" @click="submitClick('park')">新增标签</el-button>
            <el-upload             :on-remove="handleRemove_park"             :limit="1"             :on-exceed="exceedHandle"
             :file-list="filelist_park"             :name="'files'"              :data="uploadData_park"
              :action="api.baseUrl+'/file/uploadfilebatch'"              :on-success="addImgSuccessHandle_park"             list-type="picture">
              <div  v-if="filelist_park.length==0" class="mytriggerDiv" slot="trigger" @click="addImgClick('park')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
            </el-upload>
          </div>

          <div class="listWrap">
            <div class="oneItem" v-for="(list,index) in list_park" >
              <img :src="IMG_PREV+list.tag_icon" alt="">
              <span class="imgDes"> {{list.tag_name}}</span>
              <span class="deleteIcon" @click='deleteTag(list)'>
                 <i class="el-icon-delete"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 第4块 -->
      <div class="panelBlock">
        <div class="panelTitle">商家标签</div>
        <div class="panelContent">
          <div class="uploadAreaWrap">

            <input type="text" placeholder="请输入标签文字说明" v-model="input_store">
            <el-button type='primary' class="btn" @click="submitClick('store')">新增标签</el-button>
            <el-upload             :on-remove="handleRemove_store"             :limit="1"             :on-exceed="exceedHandle"
             :file-list="filelist_store"             :name="'files'"              :data="uploadData_store"
              :action="api.baseUrl+'/file/uploadfilebatch'"              :on-success="addImgSuccessHandle_store"             list-type="picture">
              <div v-if="filelist_store.length==0" class="mytriggerDiv" slot="trigger" @click="addImgClick('store')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
            </el-upload>
          </div>

          <div class="listWrap">
            <div class="oneItem" v-for="(list,index) in list_store" >
              <img :src="IMG_PREV+list.tag_icon" alt="">
              <span class="imgDes"> {{list.tag_name}}</span>
              <span class="deleteIcon" @click='deleteTag(list)'>
                 <i class="el-icon-delete"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 第5块 -->
      <div class="panelBlock">
        <div class="panelTitle">商品标签</div>
        <div class="panelContent">
          <div class="uploadAreaWrap">

            <input type="text" placeholder="请输入标签文字说明" v-model="input_item">
            <el-button type='primary' class="btn" @click="submitClick('item')">新增标签</el-button>
            <el-upload             :on-remove="handleRemove_item"             :limit="1"             :on-exceed="exceedHandle"
             :file-list="filelist_item"             :name="'files'"              :data="uploadData_item"
              :action="api.baseUrl+'/file/uploadfilebatch'"              :on-success="addImgSuccessHandle_item"             list-type="picture">
              <div v-if="filelist_item.length==0"  class="mytriggerDiv" slot="trigger" @click="addImgClick('item')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
            </el-upload>
          </div>

          <div class="listWrap">
            <div class="oneItem" v-for="(list,index) in list_item" >
              <img :src="IMG_PREV+list.tag_icon" alt="">
              <span class="imgDes"> {{list.tag_name}}</span>
              <span class="deleteIcon" @click='deleteTag(list)'>
                 <i class="el-icon-delete"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

		</div>
	</div>
</template>

<script>
	import {json,wordData,utils} from '@/common/common.js'
	import { ajaxPost,api } from '@/common/request.js'
  import AMap from 'AMap'
  // import {      ajaxApp} from '@/common/request_app.js'
	export default {
		name: 'adminIndex',
		data() {
			return {
        imageType:'',
        // 所有类型数据字典
        list_map_store:[],
        list_map_park:[],
        list_item:[],
        list_store:[],
        list_park:[],
        // 所有类型input框
        input_map_store:'',
        input_map_park:'',
        input_item:'',
        input_store:'',
        input_park:'',
        // 所有类型filelist
        filelist_map_store:[],
        filelist_map_park:[],
        filelist_item:[],
        filelist_store:[],
        filelist_park:[],
        // 所有类型uploaddata
        uploadData_map_store:{},
        uploadData_map_park:{},
        uploadData_store:{},
        uploadData_item:{},
        uploadData_park:{},

        // 11701：标签类（园区/店铺/商品）图标11801：（园区/店铺）地图图标类



			}
		},
		computed: {
			IMG_PREV(){
				return api.imgPrev
			},
      api(){
        return api
      },
      adminId() {
          return utils.getAdminId()
      },
		},
		components: {
		},
		methods: {
      exceedHandle(){
        // alert("只允许上传一张")
      },
      // 上传图片成功与删除成功时更新filelist绑定的值
      //1
      addImgSuccessHandle_map_store(res, file,fileList){
        if(res.errorCode==200){
          file.wwData=res.data
          this.filelist_map_store=fileList
        }
      },
      handleRemove_map_store(file, fileList) {
        this.filelist_map_store=fileList
      },
      // 2
      addImgSuccessHandle_map_park(res, file,fileList){
        if(res.errorCode==200){
          file.wwData=res.data
          this.filelist_map_park=fileList
        }
      },
      handleRemove_map_park(file, fileList) {
        this.filelist_map_park=fileList
      },
      // 3
      addImgSuccessHandle_park(res, file,fileList){
        if(res.errorCode==200){
          file.wwData=res.data
          this.filelist_park=fileList
        }
      },
      handleRemove_park(file, fileList) {
        this.filelist_park=fileList
      },
      // 4
      addImgSuccessHandle_item(res, file,fileList){
        if(res.errorCode==200){
          file.wwData=res.data
          this.filelist_item=fileList
        }
      },
      handleRemove_item(file, fileList) {
        this.filelist_item=fileList
      },
      // 5
      addImgSuccessHandle_store(res, file,fileList){
        if(res.errorCode==200){
          file.wwData=res.data
          this.filelist_store=fileList
        }
      },
      handleRemove_store(file, fileList) {
        this.filelist_store=fileList
      },

      addImgClick(type){// 11701：标签类（园区/店铺/商品）图标;11801：（园区/店铺）地图图标类
        let _this=this
        if(type=='map_store'||type=='map_park'){
           _this.imageType=11801
        }
        if(type=='park'||type=='store'||type=='item'){
           _this.imageType=11701
        }
        var uploadKey='uploadData_'+type
        this[uploadKey]={
          imageType: _this.imageType,
          imageUserId: _this.adminId,
        }
      },

      refreshPage(){

        this.imageType=''
        // 所有类型数据字典
        this.list_map_store=[]
        this.list_map_park=[]
        this.list_item=[]
        this.list_store=[]
        this.list_park=[]
        // 所有类型input框
        this.input_map_store=''
        this.input_map_park=''
        this.input_item=''
        this.input_store=''
        this.input_park=''
        // 所有类型filelist
        this.filelist_map_store=[]
        this.filelist_map_park=[]
        this.filelist_item=[]
        this.filelist_store=[]
        this.filelist_park=[]
        // 所有类型uploaddata
        this.uploadData_map_park={}
        this.uploadData_store={}
        this.uploadData_item={}
        this.uploadData_park={}

        this.getList("park")
        this.getList("store")
        this.getList("item")
        this.getList("map_store")
        this.getList("map_park")
      },
      deleteTag(list){
        if(confirm("确认删除"+list.tag_name+'标签吗?')){
          let id=list.tag_id
          let _this=this
          let arg={
            tagId:id,
            adminId:_this.adminId
          }
          ajaxPost('/tag/updateTagStatus', arg).then(function(res) {
            if(res.errorCode==200){
              _this.$message({
                 message: "删除成功",
                 type: 'success',
              });
              _this.refreshPage()
            }else{

            }
          }, function(res) {})
        }

      },
      getDataFromFile(filelist){
        let result=[]
        let obj={}
        if(!filelist||filelist.length==0){
        }else{
          obj=filelist[0].wwData
          result.push(obj)
        }
        return JSON.stringify(result)
      },
      submitClick(type){
        let _this=this
        // if(type=='map_store'){

        // }
        let arg={}
        var inputKey='input_'+type
        var fileKey="filelist_"+type
        if(!_this[inputKey]){
          // alert(inputKey+"必须填写内容")
          _this.$message({
             message: "请在输入框里填写图标名称",
             type: 'error',
          });
        }else if(!_this[fileKey]||_this[fileKey].length==0){
          // alert(fileKey+"必须上传图片")
          _this.$message({
             message: "您还未上传小图标",
             type: 'error',
          });
        }else{
          arg={
            tagType:type,
            tagName:_this[inputKey],
            tagIcon:_this.getDataFromFile(_this[fileKey]),
            adminId:_this.adminId
          }
          console.log(arg)
          this.submitAjax(arg)
        }


      },
      submitAjax(arg){
        let _this=this
        console.log(arg)
        ajaxPost('/tag/addTag', arg).then(function(res) {
          if(res.errorCode==200){
            _this.$message({
               message: "新增成功",
               type: 'success',
            });
            _this.refreshPage()
          }else{
            _this.$message({
               message: res.errorMsg,
               type: 'error',
            });
          }
        }, function(res) {})
      },
			getList(type){
        let _this=this
        console.log(arg)
        let arg={tagType:type}
        ajaxPost('/tag/tagList', arg).then(function(res) {
          if(res.errorCode==200){
            let keyname='list_'+type
            _this[keyname]=res.data

          }else{

          }
        }, function(res) {})
      },
      back(){
				this.$router.back()
			},
		},
		mounted() {
			let _this = this
      this.refreshPage()
		},
		destroyed(){
		}
	}

</script>
<style   lang="scss">
	* {
		// outline: 1px solid blue;
	}
  .tagAdd{background: #fff;padding:10px 10px;margin-bottom:20px;

    .panelBlock{
      border:1px solid #eee;padding:15px 20px; margin-bottom: 10px;box-shadow: 0 0 15px #aaa;border-radius: 0px;
      .panelTitle{font-weight: bold;padding-bottom:20px;}
      .panelContent{
        .uploadAreaWrap{
          display: inline-block;padding:10px 20px;
          box-shadow: 0 0 12px #ddd;
        }
        .listWrap{
          display: inline-block;
        }
      }

    }
    .oneItem{
      position: relative; font-size: 12px;box-shadow: 2px 2px 3px #eee;
        text-align: center;
       padding:15px;margin:20px 10px; display: inline-block;border-radius: 4px;border:1px solid #eee;
       img{height: 40px;width: auto;}
      .imgDes{display: block;}
      .deleteIcon{cursor: pointer; background: #409EFF;color:#fff;padding:1px;font-size: 12px; width: 20px;
      border-radius: 8px;position: absolute;top:-10px;right:-5px;}
    }
    .oneItem:hover{
      border:1px solid cadetblue;
      .deleteIcon:hover{background: cadetblue;}
    }

    .prevImgBox{
      width: 100px;height: 100px;display:inline-block;
      img{max-width: 100%;height: 100%;}
    }
    .mytriggerDiv{border:1px dotted #aaa;padding:30px;border-radius: 4px;margin:10px;}
    .el-upload-list--picture .el-upload-list__item-thumbnail{width: auto !important;}
  }


</style>



// WEBPACK FOOTER //
// src/pages/tag/index.vue